import { Card } from "@/components/ui/card";

const TONES = {
  emerald: "text-emerald-600 dark:text-emerald-400",
  rose: "text-rose-600 dark:text-rose-400",
  blue: "text-blue-600 dark:text-blue-400",
  amber: "text-amber-600 dark:text-amber-400",
};

export function Stat({ label, value, tone, icon: Icon, hint, testId }) {
  return (
    <Card className="p-4 kpi-glow min-w-0" data-testid={testId}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground font-medium">{label}</div>
          <div className={`font-display font-bold text-lg sm:text-xl mt-1.5 break-words tabular-nums ${TONES[tone] || ""}`}>{value}</div>
          {hint && <div className="text-xs text-muted-foreground mt-0.5 break-words">{hint}</div>}
        </div>
        {Icon && <Icon className="w-4 h-4 text-muted-foreground shrink-0" />}
      </div>
    </Card>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div className="min-w-0">
        <h1 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export const profitTone = (v) => (v == null ? undefined : v >= 0 ? "emerald" : "rose");
